import { render, staticRenderFns } from "./FormulaEditor.vue?vue&type=template&id=7bfd9705&scoped=true"
import script from "./FormulaEditor.vue?vue&type=script&lang=ts"
export * from "./FormulaEditor.vue?vue&type=script&lang=ts"
import style0 from "./FormulaEditor.vue?vue&type=style&index=0&id=7bfd9705&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfd9705",
  null
  
)

/* custom blocks */
import block0 from "./FormulaEditor.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports